import type { ListCollection, SelectValueChangeDetails } from '@ark-ui/solid'
import type { FieldElementProps, FieldStore } from '@modular-forms/solid'
import { ChevronDownIcon } from 'lucide-solid'
import { type Component, Index, type JSX, Show } from 'solid-js'
import { Select } from '../ui/select'

export const SelectField: Component<{
	onChange: (values: SelectValueChangeDetails<any>) => void
	field: FieldStore<any, any>
	innerTemplate?: (value: string) => JSX.Element
	formFieldProps: FieldElementProps<any, any>
	collection: ListCollection<any>
}> = (props) => {
	return (
		<Select.Root
			collection={props.collection}
			value={props.field.value ? [props.field.value] : undefined}
			invalid={!!props.field.error}
			name={props.field.name}
			positioning={{
				fitViewport: true,
				sameWidth: true,
			}}
			onValueChange={props.onChange}
		>
			<Select.Control>
				<Select.Trigger borderColor={props.field.error && 'fg.error'}>
					<Select.ValueText />
					<Select.Indicator>
						<ChevronDownIcon />
					</Select.Indicator>
				</Select.Trigger>
			</Select.Control>
			<Select.Positioner>
				<Select.Content>
					<Select.ItemGroup>
						<Index each={props.collection.items}>
							{(item) => (
								<Select.Item item={item()}>
									<Show
										when={props.innerTemplate}
										fallback={
										  <Select.ItemText>{item()?.label || item()}</Select.ItemText>
										}
									>
										{props.innerTemplate!(item()?.label || item())}
									</Show>
									<Select.ItemIndicator>✓</Select.ItemIndicator>
								</Select.Item>
							)}
						</Index>
					</Select.ItemGroup>
				</Select.Content>
			</Select.Positioner>
			<Select.HiddenSelect {...props.formFieldProps} />
		</Select.Root>
	)
}
